// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bu-2";
export var aiChatCartContainerExit = "_bu-4";
export var aiChatContainerLarge = "_bu-0";
export var aiChatContainerSmall = "_bu-1";
export var aiChatIcon = "_bu-6";
export var slideInFromRight = "_bu-3";
export var slideOutToRight = "_bu-5";